import {ChangeDetectionStrategy, Component, EventEmitter, Output} from '@angular/core';
import {TranslatorService} from '../../translation/translator.service';
import {environment} from '../../../environments/environment';

@Component({
  selector: 'app-chatbot-startscreen',
  templateUrl: './chatbot-startscreen.component.html',
  styleUrls: ['./chatbot-startscreen.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChatbotStartscreenComponent {
  @Output() startSample = new EventEmitter<string>();

  isExpanded: boolean = false;
  isMeshModeAvailable = environment.FEATURE_CHATBOT_TEAMS_FUNCTION;

  suggestionList = [
    {
      title: this.__('Prompt-1-Title'),
      content: this.__('Prompt-1-Content'),
      hint: null
    },
    {
      title: this.__('Prompt-2-Title'),
      content: this.__('Prompt-2-Content'),
      hint: null
    },
    {
      title: this.__('Prompt-3-Title'),
      content: this.__('Prompt-3-Content'),
      hint: null
    },
    {
      title: this.__('Prompt-4-Title'),
      content: this.__('Prompt-4-Content'),
      hint: null
    }
    // Mesh mode related prompts
    //
    // {
    //   title: this.__('Prompt-5-Title'),
    //   content: this.__('Prompt-5-Content'),
    //   hint: this.__('Prompt-5-Hint')
    // },
    // {
    //   title: this.__('Prompt-6-Title'),
    //   content: this.__('Prompt-6-Content'),
    //   hint: this.__('Prompt-6-Hint')
    // },
  ];

  constructor(
    private translatorService: TranslatorService
  ) {}

  toggleExpand(): void{
    this.isExpanded = !this.isExpanded;
  }

  sendMessage(title: string, content: string) {
    if (content.trim() === '') {
      this.startSample.emit(title);
    }
    else {
      this.startSample.emit(content);
    }
  }
  __(key: string): string {
    return this.translatorService.translate('chatbot-startscreen.' + key);
  }
}
